import { AMBIENT_URL_PATTERN } from "@/modules/health-wallet/public-queries"

// Ambient's card frame loads a single-use session URL. The frame is blocked from replays, but its resource timing
// entry still carries the URL into replay and tracing data.

/** `ignoreSpans` filter for the frame's resource span in transactions. */
export const AMBIENT_CARD_FRAME_SPAN = { op: "resource.iframe", name: AMBIENT_URL_PATTERN }

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null
}

/** True for the replay performance span that records the frame's resource timing entry. */
export function isAmbientCardFrameRecording(event: unknown): boolean {
  if (!isRecord(event) || !isRecord(event.data) || event.data.tag !== "performanceSpan") return false
  const payload = event.data.payload
  return (
    isRecord(payload) &&
    payload.op === "resource.iframe" &&
    typeof payload.description === "string" &&
    AMBIENT_URL_PATTERN.test(payload.description)
  )
}
